"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATE_STATUS_SUCCESS = exports.VALIDATE_STATUS_ERROR = exports.THROTTLE_TOGGLE_SHOW_PICKER = exports.SEARCH_DELAY = exports.SCROLL_SPACE = exports.MAX_HEIGHT = exports.ITEM_PADDING = exports.ICON_SORT = exports.ICON_EXPAND_MORE = exports.ICON_EXPAND_LESS = exports.HoverSource = void 0;
var MAX_HEIGHT = 365;
exports.MAX_HEIGHT = MAX_HEIGHT;
var SCROLL_SPACE = 40;
exports.SCROLL_SPACE = SCROLL_SPACE;
var ITEM_PADDING = '10px';
exports.ITEM_PADDING = ITEM_PADDING;
var ICON_EXPAND_MORE = 'ExpandMoreIcon';
exports.ICON_EXPAND_MORE = ICON_EXPAND_MORE;
var ICON_EXPAND_LESS = 'ExpandLessIcon';
exports.ICON_EXPAND_LESS = ICON_EXPAND_LESS;
var ICON_SORT = 'Sort';
exports.ICON_SORT = ICON_SORT;
var VALIDATE_STATUS_SUCCESS = 'success';
exports.VALIDATE_STATUS_SUCCESS = VALIDATE_STATUS_SUCCESS;
var VALIDATE_STATUS_ERROR = 'error';
exports.VALIDATE_STATUS_ERROR = VALIDATE_STATUS_ERROR;
var THROTTLE_TOGGLE_SHOW_PICKER = 200;
exports.THROTTLE_TOGGLE_SHOW_PICKER = THROTTLE_TOGGLE_SHOW_PICKER;
var SEARCH_DELAY = 500;
exports.SEARCH_DELAY = SEARCH_DELAY;
var HoverSource = {
  MouseOver: 'MouseOver',
  KeyBoard: 'KeyBoard'
};
exports.HoverSource = HoverSource;